import moment from 'moment';
import API from '../../../hooks/api';
import { localStorageHelper } from '../../../hooks/localStorageHelper';
import { PROFILE_KEY, SESSOIN_EXPIRY_KEY } from '../../../utils/Constants';
import { userLoginData } from './ScreenHelper';

export const loginAPI = async (
        data: userLoginData,
        callBack: (success: boolean, errorMsg: string | null) => void = () => {}
    ) => {
    await API.post("/operations/login", {
        uid: data?.email,
        password: data?.password,
    })
    .then((res) => {
        localStorageHelper.store(PROFILE_KEY, { access_token: res?.data?.access_token });
        localStorageHelper.store(SESSOIN_EXPIRY_KEY, moment().clone().add(res?.data?.expires_in, 'seconds'));
        callBack(true, null);
    })
    .catch((err) => {
        console.log("error", err);
        callBack(false, err);
    });
}
